export default __webpack_public_path__ + "static/media/storageUnit1-afterD-1920w.fdc35a46.webp";